import { combineEpics } from 'redux-observable';
import { fetchAllInventoryAllergensEpic } from '@/store/epics/staff/assets/allergens/fetch-all-allergens';

export const combinedInventoryAllergenEpics = combineEpics(
    fetchAllInventoryAllergensEpic,
);
